"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default = (0, _styles.makeStyles)(function (theme) {
  var _input;

  var placeholder = {
    color: "".concat(theme.palette.neutral.stainless),
    fontFamily: theme.typography.fontFamilyRegular,
    // !important is required because Material UI also has it in its own styles
    opacity: '1 !important'
  };
  return {
    root: (0, _defineProperty2.default)({
      position: 'relative',
      backgroundColor: 'white',
      '&$focused $outline': {
        border: "2px solid ".concat(theme.palette.sapphire[500])
      },
      '&$error $outline': {
        border: "1px solid ".concat(theme.palette.error.main)
      },
      '&$error$focused $outline': {
        border: "2px solid ".concat(theme.palette.error.main)
      },
      '&$disabled $outline': {
        borderColor: theme.palette.neutral.stainless
      },
      '&.Mui-error ': {
        backgroundColor: theme.palette.cardinal[50]
      },
      '&.Mui-warning': {
        backgroundColor: '#fefaf1'
      }
    }, ['&$focused.Mui-error', '&$focused.Mui-warning'], {
      backgroundColor: 'white'
    }),
    formControl: {},
    focused: {},
    disabled: {},
    error: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: theme.spacing(2)
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: theme.spacing(2)
    },
    colorSecondary: {
      '& $outline': {
        border: "1px solid ".concat(theme.palette.warning.main)
      },
      '&:hover:not($disabled):not($focused) $outline': {
        border: "1px solid ".concat(theme.palette.warning.main)
      },
      '&$focused $outline': {
        border: "2px solid ".concat(theme.palette.warning.main)
      }
    },
    input: (_input = {
      fontSize: theme.typography.pxToRem(16),
      height: 16,
      padding: theme.spacing(2),
      '$disabled &': {
        '-webkit-text-fill-color': theme.palette.neutral.mono,
        color: theme.palette.neutral.mono
      }
    }, (0, _defineProperty2.default)(_input, theme.breakpoints.up(1024), {
      fontSize: theme.typography.pxToRem(18),
      padding: theme.spacing(2),
      height: '1.3333333em'
    }), (0, _defineProperty2.default)(_input, '&::-webkit-input-placeholder', _objectSpread(_objectSpread({}, placeholder), {}, {
      // to align it properly in Safari
      lineHeight: 'normal'
    })), (0, _defineProperty2.default)(_input, '&::-moz-placeholder', placeholder), (0, _defineProperty2.default)(_input, '&:-ms-input-placeholder', placeholder), (0, _defineProperty2.default)(_input, '&::-ms-input-placeholder', placeholder), (0, _defineProperty2.default)(_input, 'label[data-shrink=false] + $formControl &', {
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus::-webkit-input-placeholder': placeholder,
      '&:focus::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:focus:-ms-input-placeholder': placeholder,
      // IE 11
      '&:focus::-ms-input-placeholder': placeholder // Edge

    }), _input),
    inputMultiline: (0, _defineProperty2.default)({
      height: 'auto'
    }, theme.breakpoints.up(1024), {
      height: 'auto'
    }),
    inputAdornedStart: {
      paddingLeft: 0
    },
    inputAdornedEnd: {
      paddingRight: 0
    },
    outline: {
      position: 'absolute',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      border: "1px solid ".concat(theme.palette.neutral.fog),
      pointerEvents: 'none'
    }
  };
}, {
  name: 'PdsInput'
});

exports.default = _default;
